<template>
	<div class="c-app flex-row align-items-center">
		<CContainer>
			<CRow class="justify-content-center">
				<CCol md="12">
					<CCardGroup>
						<CCard
							color="primary"
							text-color="white"
							class="text-center d-md-down-none"
							body-wrapper
						>
							<CCardBody>
								<img
									:src="logo"
									style="width: 13rem; height: 3rem"
									class="mb-2"
								/>
								<img :src="loginImg" style="width: 24rem; height: 14rem" />

								<h3>Your Prescription for Savings</h3>
							</CCardBody>
						</CCard>
						<CCard class="p-4">
							<CCardBody>
								<div class="p-4">
									<h1>Set Password</h1>
									<p class="text-muted">Set your password</p>
									<CInput
										placeholder="Password"
										type="password"
										autocomplete="curent-password"
										:value.sync="$v.profile.password.$model"
										:lazy="false"
										:isValid="checkIfValid('password')"
										:invalidFeedback="`Enter a valid password. Min 8 characters`"
										class="login-form-group"
										@keyup.enter="handleSetPassword"
									>
										<template #prepend-content>
											<CIcon name="cil-lock-locked" />
										</template>
									</CInput>
									<CInput
										placeholder="Confirm Password"
										type="password"
										autocomplete="curent-password"
										:value.sync="$v.profile.confirmPassword.$model"
										:lazy="false"
										:isValid="checkIfValid('confirmPassword')"
										invalidFeedback="Confirm password should match the password"
										class="login-form-group"
										@keyup.enter="handleSetPassword"
									>
										<template #prepend-content>
											<CIcon name="cil-lock-locked" />
										</template>
									</CInput>
									<p
										:style="{
											color: 'red',
											textAlign: 'center',
										}"
									>
										{{ error }}
									</p>
									<CRow>
										<CCol col="6" class="text-left">
											<CButton
												color="primary"
												@click="handleSetPassword"
												class="px-4"
												>Submit
											</CButton>
										</CCol>
									</CRow>
								</div>
							</CCardBody>
						</CCard>
					</CCardGroup>
				</CCol>
			</CRow>
		</CContainer>
		<div class="vld-parent" v-if="isLoading">
			<loading
				:active.sync="isLoading"
				:can-cancel="false"
				:is-full-page="true"
				loader="dots"
			></loading>
		</div>
	</div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import logo from "../../assets/images/logo.svg";
import loginImg from "../../assets/images/login-img.png";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";

export default {
	name: "Login",
	components: {
		Loading,
	},
	data() {
		return {
			logo,
			loginImg,
			isLoading: false,
			profile: {
				confirmPassword: "",
				password: "",
				email: "",
				id: "",
			},
			error: "",
		};
	},
	mixins: [validationMixin],
	validations: {
		profile: {
			confirmPassword: {
				required,
				isValid() {
					if (this.profile.password === this.profile.confirmPassword)
						return true;
					return false;
				},
			},
			password: {
				required,
				minLength: minLength(8),
			},
		},
	},
	methods: {
		checkIfValid(fieldName) {
			const field = this.$v.profile[fieldName];
			if (!field.$dirty) {
				return null;
			}
			return !(field.$invalid || field.$model === "");
		},

		validate() {
			this.$v.$touch();
		},
		reset() {
			this.profile = {
				confirmPassword: "",
				password: "",
			};
		},
		async handleSetPassword() {
			this.validate();
			if (!this.$v.$invalid) {
				this.isLoading = true;
				let { id, email, password } = this.profile;
				const res = await axios.post(process.env.VUE_APP_STORE_PASSWORD, {
					id,
					email,
					password,
				});

				const result = JSON.parse(res.data.body);
				this.isLoading = false;
				if (result.statusCode === 200) {
					this.$router.push("/login");
				} else {
					this.error = result.message;
				}
			}
		},
	},
	async beforeMount() {
		this.profile.id = this.$route.params.id;

		const res = await axios.post(
			process.env.VUE_APP_HASURA_URL,
			{
				query: GET_EMAIL_ON_ID,
				variables: {
					id: this.profile.id,
				},
			},
			{
				headers: {
					"x-hasura-user-id": this.profile.id,
				},
			}
		);

		const result = res.data.data.spendmd_db_users;
		if (result.length > 0) {
			this.profile.email = result[0].email;
		} else {
			this.error = "User not found";
			this.$router.push("/login");
		}
	},
};

const GET_EMAIL_ON_ID = `
  query ($id: uuid) {
    spendmd_db_users(
      where: { id: { _eq: $id } }
    ) {
      email
    }
  }
`;
</script>

<style scoped>
.login-form-group {
	margin-bottom: 1rem !important;
}
</style>
